import React, { useState } from 'react';
import { CalendarCheckIcon, ChevronDownIcon } from 'lucide-react';
import { loans, type Loan } from '../data/loanData';
import { formatVolume } from '../data/pipeline';
type ClosingsCardProps = {
  onOpenLoan: (loan: Loan) => void;
};
export function ClosingsCard({
  onOpenLoan
}: ClosingsCardProps) {
  const [collapsed, setCollapsed] = useState(false);
  const upcoming = [...loans].sort((a, b) => a.closingDate.localeCompare(b.closingDate));
  return <section className="rounded-xl border border-gray-200 bg-white" aria-labelledby="closings-heading" data-id="element-73" data-mp="14jt56sgcfzr5">
      <div role="button" tabIndex={0} aria-expanded={!collapsed} aria-controls="closings-list" onClick={() => setCollapsed(prev => !prev)} onKeyDown={event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setCollapsed(prev => !prev);
      }
    }} className="flex cursor-pointer select-none items-center gap-2 border-b border-gray-200 px-5 py-3.5 transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand/30" data-id="element-74" data-mp="1j97gw77e6t9p">
        <CalendarCheckIcon className="h-4 w-4 text-gray-500" aria-hidden="true" data-id="element-75" data-mp="3h5kyekahqi1x" />
        <h2 id="closings-heading" className="text-[14px] font-semibold text-ink" data-id="element-76" data-mp="3m460yqd7tdtj">
          Upcoming closings
        </h2>
        <span className="ml-auto text-[12px] text-gray-500" data-id="element-77" data-mp="2peouwaablprb">
          {formatVolume(upcoming.reduce((total, loan) => total + loan.amount, 0))}
        </span>
        <ChevronDownIcon className={['h-4 w-4 shrink-0 text-gray-400 transition-transform', collapsed ? '-rotate-90' : 'rotate-0'].join(' ')} aria-hidden="true" data-id="element-78" data-mp="2yebmy5h5tj7p" />
      </div>

      <ul id="closings-list" hidden={collapsed} className="divide-y divide-gray-100" data-id="element-79" data-mp="dn1cdzieo8fk">
        {upcoming.map(loan => <li key={loan.id} data-id="element-80" data-mp="il2yktb4onv9">
            <button type="button" onClick={() => onOpenLoan(loan)} className="flex w-full items-center gap-3 px-5 py-2.5 text-left transition-colors hover:bg-gray-50" data-id="element-81" data-mp="3p466yhtyfqgn">
              <span className="w-14 shrink-0 text-[12px] font-semibold text-ink" data-id="element-82" data-mp="2x7upbzdm6uj">
                {loan.closingDate}
              </span>
              <span className="min-w-0 flex-1" data-id="element-83" data-mp="3u40tyaalzvwf">
                <span className="block truncate text-[12.5px] text-ink" data-id="element-84" data-mp="36d56fpd6rmuz">
                  {loan.borrower}
                </span>
                <span className="block truncate text-[11.5px] text-gray-500" data-id="element-85" data-mp="31fwlxi4kf6qk">
                  {loan.number} · {loan.stage}
                </span>
              </span>
              <span className="shrink-0 text-[12px] text-gray-600" data-id="element-86" data-mp="3bc824j7a0gqa">
                {formatVolume(loan.amount)}
              </span>
            </button>
          </li>)}
      </ul>
    </section>;
}